import LinkedIn from "../../components/LinkedIn";
import { order } from "../SmartSearchParammeter";

export default async function LinkedInConfig(key) {
  return {
    description: "LinkedIn",
    id: "linkedIn",
    initial: undefined,
    type: order.third,
    handleValues: (searchObject) => {
      return;
    },

    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <LinkedIn searchObject={searchObject} onChange={onChange} t={t} />
      </div>
    ),
    operation: ["Exact", "Like"],
    list: [],

    handler: function (searchObj, value) {
      searchObj["linkedIn"] = value[0];
    }
  };
}
